/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-cycle */
import React, { useState, useEffect, useRef } from 'react';
import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Page,
  Selection, Toolbar, Edit, Sort, Filter, ColumnChooser, Resize,
  PdfExport,
  ExcelExport,
} from '@syncfusion/ej2-react-grids';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { ToolbarComponent, ItemsDirective, ItemDirective } from '@syncfusion/ej2-react-navigations';
import { DialogUtility } from '@syncfusion/ej2-react-popups';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import axios from 'axios';
import { useStateContext } from '../contexts/ContextProvider';
import Header from './Header';
import { devlogGrid, devlogCfgGrid } from '../data/dummy';
import '../pages/Zackat.css';

function DevLog({ props }) {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=associatescontrolcenter');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const {
    boss,
  } = useStateContext();
  const [pauseEnable, setPause] = useState(false);
  const grid = useRef(null);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [devlogCfg, setDevlogCfg] = useState([]);
  const [reload, setReload] = useState(true);
  const [viewDevlogs, setViewDevlogs] = useState(true);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [fromHere, setFromHere] = useState(new Date());
  const [toHere, setToHere] = useState(new Date());

  const pause = { text: 'Pause', tooltipText: 'Pause Refresh', prefixIcon: 'e-pause', id: 'pause', disabled: pauseEnable };
  const resume = { text: 'Resume', tooltipText: 'Resume Refresh', prefixIcon: 'e-repeat', id: 'resume', disabled: !pauseEnable };
  const cfg = { text: 'Toggle', tooltipText: 'Toggle Configuration', prefixIcon: 'e-settings', id: 'cfg' };
  const excel = { text: 'Excel Export', tooltipText: 'Export', prefixIcon: 'e-export-excel', id: 'excel', visible: boss, disabled: false };
  const add = { text: 'Add', tooltipText: 'Add DevLog', prefixIcon: 'e-add', id: 'add', visible: !viewDevlogs };
  const edit = { text: 'Edit', tooltipText: 'Edit DevLog', prefixIcon: 'e-edit', id: 'edit', visible: !viewDevlogs };

  const toolbarOptions = [add, edit, pause, resume, cfg, excel, 'Search'];
  const [searchParams] = useSearchParams();
  let associateid = searchParams.get('id');
  let assocId = searchParams.get('name');
  let name = 'DevLogs for ';
  let device = searchParams.get('device');
  let myfont = '';
  let source = 'zackat-div';

  const [loglimit, setLogLimit] = useState(localStorage.getItem('logLimit') || 30);
  /*
  const sortingOptions = {
    columns: [{ field: 'uploaded', direction: 'Descending' }],
  };
  */
  if (props && props._id && props._id.length > 0 && props.name && props.name.length > 0) {
    associateid = props._id;
    assocId = props.name;
    device = props.device;
    name += props.name;
    source = props.source;
    myfont = 'e-mygrid';
  } else if (props && props._id && props._id.length > 0 && props.device.length > 0) {
    associateid = props.associateid;
    assocId = props.device;
    device = props.device;
    name += props.device;
    source = props.source;
    myfont = 'e-mygrid';
  } else if (associateid) {
    name += `${assocId}`;
  } else {
    name += `${device}`;
    associateid = null;
  }
  const setLimits = () => {
    const lim = document.getElementById('limit').value;
    setData([]);
    setFrom(0);
    setTo(0);
    setFromHere(new Date());
    setToHere(new Date());
    setLogLimit(lim);
    localStorage.setItem('logLimit', Number(lim));
  };
  const limitTemplate = () => (
    <div className="e-toolbar-left">
      <input type="text" id="limit" placeholder="Limit number of days" defaultValue={loglimit} className="custom-toolbar-input" />
      <button type="button" className="e-btn e-success e-outline" onClick={() => { setLimits(); }}>Limit Days</button>
    </div>
  );
  const editing = { allowDeleting: false, allowEditing: false };
  const editingCfg = {
    allowDeleting: false,
    allowEditing: true,
    allowAdding: true,
    mode: 'Dialog',
    showConfirmDialog: true,
    enableAdaptiveUI: true,
  };
  const { REACT_APP_API_ENDPOINT } = process.env;
  const calculateDays = (f, t) => {
    if (!f || !t) return null;

    const start = new Date(f);
    const end = new Date(t);

    // Get time difference in milliseconds
    const timeDiff = end.getTime() - start.getTime();

    // Convert milliseconds to days and round the value
    const dayInMs = 24 * 60 * 60 * 1000;
    const daysDiff = Math.ceil(timeDiff / dayInMs);

    return daysDiff;
  };

  const timerid = useRef();
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      if (device !== null) {
        const query = Object.entries(usr)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
        let url = `${REACT_APP_API_ENDPOINT}/devlogs?${query}&device=${device}&limit=${loglimit}`;
        if (from !== 0 && to !== 0) {
          url = `${REACT_APP_API_ENDPOINT}/devlogs?${query}&device=${device}&from=${from}&to=${to}`;
        }
        await axios({
          url,
          method: 'get',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            setData(response.data.devlogEvents);
            setDevlogCfg(response.data.devlog);
          })
          .catch((error) => {
            console.error('Got devlog error', error.message);
          });
        setLoading(false);
      }
      setLoading(false);
    };
    fetchData();
  }, [associateid, loglimit, reload]);

  async function fetchDevlogs() {
    const loc = window.location;
    if (!loc.pathname.includes('/inventory')) {
      setPause(!pauseEnable);
      if (timerid.current) {
        timerid.current = clearInterval(timerid.current);
        return;
      }
    }
    if (device != null) {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');

      let url = `${REACT_APP_API_ENDPOINT}/devlogs?${query}&device=${device}&limit=${loglimit}`;
      if (from !== 0 && to !== 0) {
        url = `${REACT_APP_API_ENDPOINT}/devlogs?${query}&device=${device}&from=${from}&to=${to}`;
      }

      await axios({
        url,
        method: 'get',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if (timerid.current) {
          setData(response.data.devlogEvents);
          setDevlogCfg(response.data.devlog);
        }
      })
        .catch((error) => {
          console.error('fetchDevLogs', error.message);
        });
    }
  }

  useEffect(() => {
    if (!pauseEnable) {
      timerid.current = setInterval(fetchDevlogs, 30000);
    }
    return () => {
      timerid.current = clearInterval(timerid.current);
    };
  }, [props, pauseEnable]);
  const flattenObject = (obj, prefix = '') => Object.keys(obj).reduce((acc, k) => {
    const pre = prefix.length ? `${prefix}.` : '';
    if (
      typeof obj[k] === 'object'
            && obj[k] !== null
            && Object.keys(obj[k]).length > 0
    ) {
      Object.assign(acc, flattenObject(obj[k], pre + k));
    } else {
      acc[pre + k] = obj[k];
    }
    return acc;
  }, {});
  const actionBegin = (args) => {
    if (args.requestType === 'add') {
      const { dialog } = args;
      if (dialog) {
        dialog.header = `Details of ${args.rowData.index}`;
        dialog.width = '50vw';
      }
      args.data.index = Number(devlogCfg.length);
    }
  };
  const actionComplete = (args) => {
    if (args.requestType === 'beginEdit' || args.requestType === 'add') {
      const { dialog } = args;
      if (dialog) {
        dialog.header = `Details of Index ${args.rowData.index}`;
        dialog.width = '50vw';
      }
    }
    if (args.requestType === 'save' && args.form && args.action === 'add') {
      if (args.data) {
        args.data.index = Number(args.data.index);
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/devlogs`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then((responseJson) => {
          // The added/edited data will be saved in the Grid
            if (!responseJson || !responseJson._id || responseJson._id.length === 0) {
              DialogUtility.alert('DevLog add failed');
              args.cancel = true;
              return;
            }
            DialogUtility.alert('DevLog add success');
            if (responseJson && responseJson._id) {
              args.data._id = responseJson._id;
            }

            setReload(!reload);
          })
          .catch(() => {
            args.cancel = true;
            DialogUtility('DevLog insert error');
          });
      }
    } else if (args.requestType === 'save' && args.form && args.action === 'edit') {
      if (args.data) {
        args.data.index = Number(args.data.index);
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/devlogs`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then((responseJson) => {
          // The added/edited data will be saved in the Grid
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              args.cancel = true;
            }
            DialogUtility.alert(`DevLog update ${responseJson.response}`);
          })
          .catch((error) => {
            DialogUtility.alert(`DevLog update error ${error.message}`);
            args.cancel = true;
          });
      }
    }
  };
  const fromTemplate = () => (
    <div className="flex">
      <span className="e-icons e-timeline-month" />
      <DateTimePickerComponent
        id="fromdate"
        onChange={(e) => {
          setFrom((e.value.getTime() / 1000).toFixed(0));
          setFromHere(e.value);
        }}
        placeholder="Select From Date/Time"
        defaultValue={fromHere}
      />
    </div>
  );
  const toTemplate = () => (
    <div className="flex">
      <span className="e-icons e-timeline-month" />
      <DateTimePickerComponent
        id="todate"
        onChange={(e) => {
          setTo((e.value.getTime() / 1000).toFixed(0));
          setToHere(e.value);
          const days = calculateDays(fromHere, e.value);
          if ((days !== null && days > 0) || e.value !== toHere) {
            setReload(days);
          }
        }}
        placeholder="Select To Date/Time"
        defaultValue={toHere}
      />
    </div>
  );

  const clickHandler = (args) => {
    if (args.item.properties.text === 'Pause') {
      setPause(!pauseEnable);
    } else if (args.item.properties.text === 'Resume') {
      setPause(!pauseEnable);
    } else if (args.item.properties.text === 'Toggle') {
      setViewDevlogs(!viewDevlogs);
    } else if (grid && grid.current && args.item.properties.text === 'Edit') {
      const selectedRecords = grid.current.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0) {
        DialogUtility.alert('Plese select a DevLog to edit!');
        return;
      }
      grid.current.startEdit(selectedRecords[0]);
    } else if (grid && args.item.properties.text === 'Add') {
      grid.current.addRecord();
    } else if (grid && grid.current && args.item.properties.text === 'PDF Export') {
      const properties = {
        fileName: `PDFExport_${name}_${new Date().toISOString()}.pdf`,
        pageOrientation: 'Landscape',
      };
      grid.current.pdfExport(flattenObject(properties));
    } else if (grid && grid.current && args.item.properties.text === 'Excel Export') {
      const properties = {
        fileName: `ExcelExport_${name}_${new Date().toISOString()}.xlsx`,
      };
      grid.current.excelExport(flattenObject(properties));
    }
  };
  if (loading) {
    return <p>Loading... </p>;
  }
  const wrapSettings = { wrapMode: 'Both' };
  const onDataBound = () => {
    const root = grid.current && grid.current.element;
    if (!root) {
      return;
    }
    const searchInput = root.querySelector('input.e-input[id$="_searchbar"]');
    if (!searchInput || searchInput.dataset.listenerAttached) {
      return;
    }
    searchInput.dataset.listenerAttached = 'true';
    searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  };
  return (
    <div
      className={source === 'controlpanel' ? 'm-1 md:m-1 mt-2 p-2 md:p-2 rounded-3xl' : 'm-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh'}
    >
      <Header category="" title={name} />
      <div id="container">
        <ToolbarComponent id="toolbar">
          <ItemsDirective>
            <ItemDirective template={limitTemplate} disabled={false} />
            <ItemDirective type="Separator" />
            {boss && <ItemDirective template={fromTemplate} disabled={false} />}
            {boss && <ItemDirective type="Separator" />}
            {boss && <ItemDirective template={toTemplate} disabled={false} />}
            {boss && <ItemDirective type="Separator" />}
          </ItemsDirective>
        </ToolbarComponent>
      </div>
      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">
            <GridComponent
              dataSource={viewDevlogs ? data : devlogCfg}
              dataBound={onDataBound}
              className={myfont}
              allowPaging
              allowSorting
              // sortSettings={sortingOptions}
              allowExcelExport
              allowPdfExport
              editSettings={viewDevlogs ? editing : editingCfg}
              toolbar={toolbarOptions}
              toolbarClick={clickHandler}
              enableHover={false}
              actionComplete={actionComplete}
              actionBegin={actionBegin}
              pageSettings={{ pageSize: 25, pageCount: 10 }}
              allowResizing
              showColumnChooser
              allowTextWrap
              textWrapSettings={wrapSettings}
              ref={grid}
              enableAdaptiveUI={false}
              enableAltRow
            >
              <ColumnsDirective>
                {viewDevlogs && devlogGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                {!viewDevlogs && devlogCfgGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
              </ColumnsDirective>
              <Inject services={[Search, Page, Selection, Toolbar, Edit, Sort, Filter, ColumnChooser, Resize, PdfExport, ExcelExport]} />
            </GridComponent>
          </div>
        </div>
      </div>
    </div>
  );
}
export default DevLog;
